var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoatClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12059_25106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.689904 8.21041H5.90711V7.3644C4.77863 7.13465 3.49339 7.14599 2.35059 7.19602C2.12892 7.21757 1.95998 6.98938 2.05366 6.78145C2.62726 5.51166 1.9322 3.41713 1.45427 2.20106C1.37462 1.99483 1.543 1.77189 1.76793 1.80208C5.07301 2.2569 7.01036 4.13558 7.45215 7.45837C7.48333 7.69691 7.22325 7.87493 7.01093 7.74893C6.86679 7.66304 6.69571 7.58678 6.49771 7.51989V8.21041H11.9104C12.24 8.21041 12.3179 8.67232 12.0107 8.7833L7.96848 10.6719C7.92809 10.6907 7.88571 10.6995 7.8439 10.6995C5.45923 10.6995 3.07457 10.7007 0.689904 10.7007C0.526769 10.7007 0.394531 10.5684 0.394531 10.4054V8.50564C0.394531 8.34265 0.526769 8.21041 0.689904 8.21041ZM1.6707 10.1102V9.55929C1.6707 9.17094 2.2613 9.17094 2.2613 9.55929V10.1102H3.11043V9.55929C3.11043 9.17094 3.70089 9.17094 3.70089 9.55929V10.1102H4.55001V9.55929C4.55001 9.17094 5.14062 9.17094 5.14062 9.55929V10.1102H5.98974V9.55929C5.98974 9.17094 6.5802 9.17094 6.5802 9.55929V10.1102H7.78097L10.5835 8.80087H0.985134V10.1102H1.6707ZM6.78104 6.99661C6.27845 4.43449 4.7371 2.96032 2.18491 2.46723C2.62215 3.67296 3.08109 5.31451 2.7432 6.59238C3.97656 6.55525 5.60593 6.56588 6.78104 6.99661Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12059_25106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.300781 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatClasses);
export default __webpack_public_path__ + "static/media/BoatClasses.fc58ace390ef4bc9dd2a977e9202ae96.svg";
export { ForwardRef as ReactComponent };